import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudTabMenuModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsMenuModule } from 'modules/notifications/notifications-menu/notifications-menu.module';
import { ShellTrackersService } from 'modules/shell/services/shell-trackers.service';
import { UserAvatarModule } from 'modules/user/components/user-avatar/user-avatar.module';
import { OverlayComponentModule } from 'shared/components/overlay/overlay.module';

import { FaqMenuModule } from '../faq-menu/faq-menu.module';
import { HeaderSubmenuModule } from '../header-submenu/header-submenu.module';
import { LogoModule } from '../logo/logo.module';
import { HeaderComponent } from './header.component';

@NgModule({
	declarations: [HeaderComponent],
	imports: [
		CommonModule,
		LogoModule,
		UserAvatarModule,
		HeaderSubmenuModule,
		FaqMenuModule,
		FreudTooltipModule,
		TranslateModule,
		FreudTabMenuModule,
		OverlayComponentModule,
		NotificationsMenuModule,
	],
	exports: [HeaderComponent],
	providers: [ShellTrackersService],
})
export class HeaderModule {}
